import React from 'react';
import { motion } from 'framer-motion';
interface ProgressBarProps {
  progress: number; // 0 to 100
}
export function ProgressBar({
  progress
}: ProgressBarProps) {
  return <div className="w-full h-2.5 bg-gray-100 rounded-full overflow-hidden" data-id="element-351">
      <motion.div className="h-full bg-brand-green rounded-full shadow-[0_0_10px_rgba(125,184,158,0.5)]" initial={{
      width: 0
    }} animate={{
      width: `${progress}%`
    }} transition={{
      duration: 0.6,
      ease: 'easeOut'
    }} data-id="element-352" />
    </div>;
}